import { createSlice } from '@reduxjs/toolkit';

export type TokenState = {
  access?: string;
  refresh?: string;
};

const initialState: TokenState = {
  access: undefined,
  refresh: undefined
};

const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    handleToken(state, action) {
      localStorage.setItem('token', JSON.stringify(action.payload));
      state.access = action.payload.access;
      state.refresh = action.payload.refresh;
    }
  }
});

export const { handleToken } = tokenSlice.actions;

export const tokenReducer = tokenSlice.reducer;
